import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

function AppointmentConfirmation() {
  const [firstName, setFirstName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [eventStart, setEventStart] = useState("");
  const [assignedTo, setAssignedTo] = useState("");

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setFirstName(params.get("invitee_first_name") || "");
    setCompanyName(params.get("answer_1") || "your company");
    setAssignedTo(params.get("assigned_to") || "our team");

    const rawDate = params.get("event_start_time");
    if (rawDate) {
      const date = new Date(rawDate);
      const formatted = date.toLocaleString("en-GB", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      setEventStart(formatted);
    }
  }, [location.search]);

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/blog", label: "Our Blog" },
    { to: "/get-in-touch", label: "Support" },
  ];

  return (
    <>
      <Header links={navLinks} />

      <Helmet>
        <title>Appointment Confirmed | DataPulse AI</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <main>
        <section className="bg-white dark:bg-gray-900">
          <div className="max-w-screen-xl py-10 mx-auto lg:py-24 lg:px-6 text-center">
            <div className="px-4 mx-auto mb-8 text-center lg:mb-12">
              <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                Thanks {firstName} - you're all booked in! ✅
              </h2>
              <p className="mb-6 font-light text-gray-500 dark:text-gray-400 md:text-lg">
                Your discovery call with <span className="font-medium text-title-purple">DataPulse AI</span> is confirmed with&nbsp;
                <a
                  href="https://www.linkedin.com/in/viren-samani"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-medium"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    color: "#0A66C2",
                  }}
                >
                  Viren Samani
                  <img
                    src="https://www.mydatapulse.co.uk/icons/linkedin.svg"
                    alt="LinkedIn"
                    style={{ width: "16px", height: "16px" }}
                  />
                  </a>
                  &nbsp;on&nbsp;
                  <br />
                  <br />
                  <span className="text-blue-600 font-bold text-3xl">🗓️ {eventStart}</span>
                  <br />
                <br />
                We’re excited to learn more about you and <span className="font-medium text-title-purple">{companyName}</span> - and explore how we can help streamline operations, unlock time, and drive smarter growth.
                <br /><br />
                You’ll receive a calendar invite shortly by email, along with a reminder closer to the time.
                <br /><br />
                If anything changes, just let us know.
                <br /><br />
                Speak soon!
              </p>

              <a href="/" className="flex text-2xl justify-center pl-4 ml-1 font-semibold text-gray-900 dark:text-white">
                &nbsp;&nbsp;<img src="./icons/1.png" className="h-6 sm:h-9" alt="DataPulse AI Logo" />
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default AppointmentConfirmation;
